import styled from 'styled-components';
import { AppCard, AppRemixIcon } from '@/layout/AppComponents';

export default function InecoRiskManagerRiskActionCard({
  action,
  onShowActionModal,
  onShowInterventionModal,
}) {
  return (
    <>
      <AppCard
        header={
          <>
            <span>Actividad/acción</span>
            <span
              className="pointer float-right"
              title="Editar"
              onClick={onShowActionModal}
            >
              <AppRemixIcon icon="edit-box" />
            </span>
          </>
        }
        headerClassName="text-white bg-primary"
        footer={
          <>
            <span>{action?.state?.name}</span>
            <span
              className={`badge float-right badge-${
                action?.closeDate ? 'danger' : 'success'
              }`}
            >
              {action?.closeDate ? `Cerrado ${action?.closeDate}` : 'Activo'}
            </span>
          </>
        }
        footerClassName="px-2 py-1"
      >
        <>
          <div className="d-flex flex justify-content-between">
            <div className="small mb-2">
              <div title="Responsable">
                <span className="font-weight-bold mr-2">Responsable:</span>
                <span>{action?.responsible?.name || '-'}</span>
              </div>
              <div title="Otro responsable">
                <span className="font-weight-bold mr-2">Otro responsable:</span>
                <span>{action?.anotherResponsible?.name || '-'}</span>
              </div>
            </div>
            <div className="small mb-2">
              <div title="Propietario">
                <span className="font-weight-bold mr-2">Propietario:</span>
                <span>{action?.owner?.name || '-'}</span>
              </div>
              <div title="Otro propietario">
                <span className="font-weight-bold mr-2">Otro propietario:</span>
                <span>{action?.anotherOwner?.name || '-'}</span>
              </div>
            </div>
          </div>
        </>
        <CardBlock>{action?.description}</CardBlock>
      </AppCard>
      <button
        type="button"
        className="btn btn-xs btn-success float-right mt-3"
        onClick={onShowInterventionModal}
      >
        Nueva actuación
      </button>
    </>
  );
}

const CardBlock = styled.div`
  min-height: 60px;
`;
